import { ShortcutsMockApi } from 'app/api/common/shortcuts/api';

export const mockApiServices = [
    ShortcutsMockApi
];
